import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';
import GridViewDetailsScreen from "./gridViewDetails";
import GridViewListScreen from "./gridViewList";


const GridViewRoutes = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ padding: '8px 12px', maxWidth: '100%' }} flexDirection="column" display={'flex'} flexGrow={1}>
            <Routes>
                <Route
                    path="/"
                    element={<GridViewListScreen onOpenGridView={(id: string) => navigate(`/gridViews/${id}`)} />}
                />
                <Route path="/:gridViewId/*" element={<GridViewDetailsScreen />} />
            </Routes>
        </Box>
    );
};

export default GridViewRoutes;
